export const toCurrencyUSD = (nbr) => {
    // return '$' + Intl.NumberFormat('en-US').format(nbr);
    const x = Number(nbr);
    const str = '$' + x.toLocaleString('en-US', {
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return (x < 0 ?  '('+str+')' : str);
};